import { OverlayIcon } from '@components/GateFigure';
import { Forward } from '@mui/icons-material';
import { Box, keyframes } from '@mui/material';

const dx0 = '0';
const dx1 = '-4px';
const dx2 = '4px';

const doubleMoveUp = keyframes`
  0% { transform: translateX(${dx0}); }
  25% { transform: translateX(${dx1}); }
  50% { transform: translateX(${dx0}); }
  75% { transform: translateX(${dx1}); }
  100% { transform: translateX(${dx0}); }
`;

const doubleMoveDown = keyframes`
  0% { transform: translateX(${dx0}); }
  25% { transform: translateX(${dx2}); }
  50% { transform: translateX(${dx0}); }
  75% { transform: translateX(${dx2}); }
  100% { transform: translateX(${dx0}); }
`;

export const InMovementIcon: OverlayIcon = ({
  canAnimate,
  position,
  moveDirection = 'up',
  ...props
}) => {
  const key = position?.toFixed(5);
  const isDown = moveDirection === 'down';
  const rotate = isDown ? '90deg' : '-90deg';

  const animationName = isDown ? doubleMoveDown : doubleMoveUp;

  const animation = canAnimate ? `${animationName} 0.8s ease-in-out` : 'none';

  return (
    <Box
      component="span"
      key={key}
      sx={{
        display: 'inline-flex',
        rotate,
        animation,
      }}
    >
      <Forward {...props} />
    </Box>
  );
};
